import { useIntl } from '@/intl'
import { useFilters } from '@/scopes/search/search/domain/hooks'

import { space } from '@sunwebgroup/ui-components'

import { Button } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

import { styled } from 'styled-components'
import { AccommodationTypeTokens } from './AccomodationTypeTokens'
import { ChildrenFacilitiesTokens } from './ChildrenFacilitiesTokens'
import { CollectionTokens } from './CollectionTokens'
import { CustomerRatingTokens } from './CustomerRatingTokens'
import { DealTokens } from './DealTokens'
import { DistanceToInterestTokens } from './DistanceToInterestTokens'
import { FacilitiesTokens } from './FacilitiesTokens'
import { InternetFacilitiesTokens } from './InternetFacilitiesTokens'
import { MealPlanTokens } from './MealPlanTokens'
import { NumberOfRoomsTokens } from './NumberOfRoomsTokens'
import { PricePerPersonTokens } from './PricePerPersonTokens'
import { StarsTokens } from './StarsTokens'
import { VacationTypeTokens } from './VacationTypeTokens'

const ResetFiltersButton = styled(Button)`
  &:first-child:last-child {
    display: none;
  }
`

const Wrapper = styled.div`

  > * {
    margin-right: ${space('primitives_space_4')};
    margin-bottom: ${space('primitives_space_8')};
  }
`

export function SelectedFiltersTokens({ withResetButton }: { withResetButton?: boolean }) {
  const intl = useIntl()
  const { resetOptionalFilters } = useFilters()

  return (
    <Wrapper>
      <AccommodationTypeTokens />
      <MealPlanTokens />
      <DealTokens />
      <FacilitiesTokens />
      <StarsTokens />
      <CustomerRatingTokens />
      <ChildrenFacilitiesTokens />
      <InternetFacilitiesTokens />
      <VacationTypeTokens />
      <NumberOfRoomsTokens />
      <DistanceToInterestTokens />
      <CollectionTokens />
      <PricePerPersonTokens />
      {withResetButton && (
        <ResetFiltersButton $type="transparentNeutral" $size="S" onClick={resetOptionalFilters}>
          {intl.formatMessage({
            id: 'search_reset_filters',
          })}
        </ResetFiltersButton>
      )}
    </Wrapper>
  )
}
